import { render } from "./Login.vue?vue&type=template&id=a503c9f6"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import exportComponent from "D:\\All\\Job freelance\\CRA-brainy\\Develop\\cra-brainy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__